import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'clickSyncProcessManagementExperience.listExport'

const ClickSyncProcessManagementClickSyncProcessListExportSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default ClickSyncProcessManagementClickSyncProcessListExportSlice
